export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('vue:error', (error, instance, info) => {
        // Error was not thrown with createError();
        if (!isNuxtError(error)) return;

        if (error.fatal) return;

        useToasts().errorToast(getErrorMessage(error));

        clearError();
    });
});
